import type { FaireProductEntity } from "../../entity_types/product";

export const p_k99gmuweu9: FaireProductEntity = {
  token: "p_k99gmuweu9",
  type: "product",
  name: "All Natural Blackberry Vegan French Macarons | Available in 24 & 48 Pack",
  brandToken: "b_384hnspyq8",
  brandName: "macaron centrale",
  imageUrl:
    "https://cdn.faire.com/fastly/82a41f33dfd5ca76f8875f9b293311ea833f94e67bc3a0431bc8f90a1a69c570.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c69647d8fab169d346fd0f61fb742d13b9e4b2230cd40a5306519aaf43cb07c8.png",
    "https://cdn.faire.com/fastly/af61873476475cf9c7402b2277d479d58d2a1a28854f4a8b842b150261a9b80c.png",
    "https://cdn.faire.com/fastly/66dd641528a71ee198c344c2a2b36e8312b89d185ed31d74c94e1c5b8e03c226.png",
    "https://cdn.faire.com/fastly/1b38be116d133ac4460fd6b53cb17fb854b3817896d92d309c9bf963639ffba4.png",
    "https://cdn.faire.com/fastly/ae06d3ab023f61e6227719bf52db3323c125ba03da49820e73193e729cb434cb.jpeg",
  ],
  priceDollars: 2.29,
  description:
    "Indulge in our all-natural blackberry vegan macarons, crafted with the finest ingredients. Each macaron features a luscious filling centered with organic blackberry compote, offering a burst of tangy and sweet flavors. These macarons are perfect for anyone who loves a delicious and guilt-free treat.",
  tags: [],
  msrpDollars: 4.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:46.961Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
